import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close, Download, Link } from "@mui/icons-material";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import { columnTextField } from "utils/tables-utils";

const columnModel = [
    columnTextField(
      {
        dataField: "DataDownload",
        text: "Data do download",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "UrlZipDownload",
        text: "URL do ZIP",
        headerAlign: "center",
        formatter: (_, row) => {
          if (!row.UrlZipDownload) return;
          const start = row?.UrlZipDownload?.slice(0, 18);
          const end = row?.UrlZipDownload?.slice(-40);
          const displayUrl = `${start}...${end}`;
          return displayUrl;
        },
      },
      false
    ),
    columnTextField(
      {
        dataField: "Status",
        text: "Status",
        align: "center",
        formatter: (_, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="body2">{row.Status}</Typography>
          </div>
        ),
      },
      false
    ),
    columnTextField(
      {
        dataField: "Download",
        text: "Download",
        align: "center",
        formatter: (_, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {row.Status == "FINALIZADO" && (
              <IconButton
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = row.UrlZipDownload;
                  link.download = "imagens.zip";
                  document.body.appendChild(link);
                  link.click();
                }}
              >
                <Download />
              </IconButton>
            )}
          </div>
        ),
      },
      false
    ),
  ];

export default function TableLinks({ close, data, searching }) {
  return (
    <Dialog open onClose={close} maxWidth={"lg"}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Link style={{ marginRight: "12px" }} />
            Links de Download
          </Typography>
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando links de download..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <ToolkitTable
            dataTable={data?.slice(0, 6)}
            searched={Boolean(data?.length > 0)}
            keyField="UrlZipDownload"
            notFoundTitle="Não foi encontrado links de downloads disponíveis."
            columnModel={columnModel}
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          />
        </DialogContent>
      )}
      <DialogActions>
        <Button variant="contained" color="primary" onClick={close}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
